import { render, staticRenderFns } from "./ProgramEditor.vue?vue&type=template&id=6a8cef50&"
import script from "./ProgramEditor.vue?vue&type=script&lang=js&"
export * from "./ProgramEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports